<template>
  <div v-loading="showFlag">
    <t-card class="card_common">
      <!-- 社内製造レポート画面 -->
      <div class="internalFactureReportForm">
        <t-form label-position="right" label-width="100px">
          <t-row
            type="flex"
            justify="left
          "
          >
            <t-col :span="16">
              <t-form-item
                :label="$t('resource.CUS_M_ORDER_AMOUNT.PERIOD')"
                class="marginBottom"
              >
                <t-select class="select-year-width" v-model="period.startYear">
                  <t-option
                    v-for="item in yearList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </t-option>
                </t-select>

                <t-select class="select-year-width" v-model="period.startMonth">
                  <t-option
                    v-for="item in monthList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </t-option>
                </t-select>
                <span>&nbsp;&nbsp;～&nbsp;&nbsp;</span>
                <t-select class="select-year-width" v-model="period.endYear">
                  <t-option
                    v-for="item in yearList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </t-option>
                </t-select>

                <t-select class="select-year-width" v-model="period.endMonth">
                  <t-option
                    v-for="item in monthList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </t-option>
                </t-select>
              </t-form-item>
            </t-col>
            <t-col :span="4" class="right">
              <!-- 検索 -->
              <t-button
                round
                type="primary"
                class="button_common_search marginRight"
                @click="searchClick()"
              >
                <i class="el-icon-search"></i>{{ $t("resource.sys.search") }}
              </t-button>
            </t-col>

            <t-col :span="4" class="right">
              <!-- 社内製造 -->
              <t-button
                round
                type="primary"
                ref="outPut"
                class="button_common_search marginRight"
                @click="outPutClick()"
              >
                <i class="el-icon-download"></i
                >{{ $t("resource.REPORT.REPORT_OUT") }}
              </t-button>
            </t-col>
          </t-row>
          <t-row>
            <t-table
              :data="internalFactureList"
              tooltip-effect="dark"
              style="width: 100%"
              header-cell-class-name="bg-default"
              :max-height="maxheight"
              :span-method="handleSpanMethod"
              highlight-current-row
              border
            >
              <t-table-column
                width="50"
                prop="col1"
                class-name="cell_txt_left"
                fixed
              ></t-table-column>

              <t-table-column
                width="100"
                prop="col2"
                class-name="cell_txt_left"
                fixed
              ></t-table-column>

              <t-table-column
                fixed
                width="150"
                prop="col3"
                class-name="cell_txt_left"
                :label="$t('resource.CUS_M_ORDER_AMOUNT.MONTH')"
              ></t-table-column>

              <t-table-column
                v-for="(column, index) in periodMonthList"
                :key="index"
                :label="column.title"
                width="120"
                class-name="cell_txt_right"
                ><template slot-scope="scope">
                  <!-- <t-input-number
                    class="cell_input_number"
                    :ref="'inputRef' + scope.$index + '_' + index"
                    :controls="false"
                    :precision="0"
                    :min="-999999"
                    :max="999999"
                    :disabled="
                      scope.row.imKbn == '1' ||
                      scope.row.imKbn == '2' ||
                      scope.row.imKbn == '3' ||
                      scope.row.imKbn == '5_1' ||
                      scope.row.imKbn == '12_1' ||
                      scope.row.imKbn == '12_2'
                    "
                    :value="scope.row.dicNumValue['sum' + (index + 1)]"
                    @change="changeCellData(scope.$index, index)"
                    @keyup.native.enter="
                      focusNextInput(
                        scope.$index,
                        index,
                        column.title,
                        scope.row.imKbn
                      )
                    "
                  ></t-input-number> -->

                  <t-input
                    v-if="editCellData(scope.row) == 'input'"
                    class="cell_input_custom"
                    :controls="false"
                    :maxlength="6"
                    :disabled="
                      scope.row.imKbn == '1' ||
                      scope.row.imKbn == '2' ||
                      scope.row.imKbn == '3' ||
                      scope.row.imKbn == '5_1' ||
                      scope.row.imKbn == '12_1' ||
                      scope.row.imKbn == '12_2'
                    "
                    v-model="scope.row.dicNumValue['sum' + (index + 1)]"
                    @blur="changeCellData(scope.$index, index)"
                    @focus="
                      changeCellDataToNumber(scope.row, 'sum' + (index + 1))
                    "
                    @input="
                      scope.row.dicNumValue['sum' + (index + 1)] =
                        scope.row.dicNumValue['sum' + (index + 1)].replace(
                          /[^\d]/g,
                          ''
                        )
                    "
                    :ref="'inputRef' + scope.$index + '_' + index"
                    @keyup.native.enter="
                      focusNextInput(
                        scope.$index,
                        index,
                        column.title,
                        scope.row.imKbn
                      )
                    "
                  ></t-input>
                  <!-- :value="scope.row.dicNumValue['sum' + (index + 1)]" -->

                  <t-input-number
                    v-else-if="editCellData(scope.row) == 'inputNumber'"
                    class="cell_input_number"
                    :ref="'inputRef' + scope.$index + '_' + index"
                    :controls="false"
                    :precision="0"
                    :min="-999999"
                    :max="999999"
                    :disabled="
                      scope.row.imKbn == '1' ||
                      scope.row.imKbn == '2' ||
                      scope.row.imKbn == '3' ||
                      scope.row.imKbn == '5_1' ||
                      scope.row.imKbn == '12_1' ||
                      scope.row.imKbn == '12_2'
                    "
                    :value="scope.row.dicNumValue['sum' + (index + 1)]"
                    @change="changeCellData(scope.$index, index)"
                    @keyup.native.enter="
                      focusNextInput(
                        scope.$index,
                        index,
                        column.title,
                        scope.row.imKbn
                      )
                    "
                  ></t-input-number>
                </template>
              </t-table-column>
            </t-table>
          </t-row>

          <t-row type="flex" justify="end">
            <div style="height: 60px">
              <t-col :span="24" style="padding-right: 20px; padding-top: 10px">
                <!--UPD 2024/12/16 ZLL 課題(#32906)_個人受注実績の見積件数が入力可能に変更 start↓ -->
                <!-- <t-button
                  type="primary"
                  style="width: 100px; height: 40px"
                  @click="confirm"
                  >{{ $t("resource.sys.sure") }}</t-button
                > -->

                <t-button
                  round
                  type="warning"
                  class="dialogButton_confirm_120_40"
                  ref="confirmBtn"
                  @click="confirm"
                  >{{ $t("resource.sys.sure") }}</t-button
                >
                <!--UPD 2024/12/16 ZLL 課題(#32906)_個人受注実績の見積件数が入力可能に変更 end↑ -->
              </t-col>
            </div>
          </t-row>
        </t-form>
      </div>
    </t-card>
  </div>
</template>
<script>
import { httpApi } from "@/api/api";
import { t } from "@/locales";
import { outputExcelToZip } from "@/services/common";
import {
  SearchInternalFactureData,
  UpdateInternalManufactureData,
} from "@/services/internalFactureReport";
import {
  formatCurrencyToNumber,
  formatStringToCurrency,
} from "@/utils/comFunction";
import { Message } from "@tellus/component";

export default {
  data() {
    return {
      //一覧高
      maxheight: window.innerHeight - 180,
      //期間年度
      yearList: [],
      //期間月度
      monthList: [],
      //期間値
      period: {
        startYear: "",
        startMonth: "",
        endYear: "",
        endMonth: "",
      },
      //期間月度
      periodMonthList: [],
      //製品データ
      internalFactureList: [],
      //製品データ(更新用)
      internalFactureOutList: [],
      //月度差
      monthsDiff: 0,
      showFlag: false,
    };
  },

  mounted() {
    this.init();

    this.$nextTick(() => {
      this.maxheight = document.body.clientHeight - 180;
    });
  },

  computed: {},

  methods: {
    // 初期化
    init() {
      this.showFlag = true;
      //システム日
      var systemDate = new Date();
      //システム年
      var systemYear = systemDate.getFullYear();
      //システム月
      var systemMonth = systemDate.getMonth();

      //年度リスト
      for (let year = 2024; year <= systemYear + 1; year++) {
        this.yearList.push({
          value: year,
          label: year + t("resource.CUS_M_ORDER_AMOUNT.YEAR"),
        });
      }

      //月度リスト
      for (let month = 1; month <= 12; month++) {
        this.monthList.push({
          value: month,
          label: month + t("resource.CUS_M_ORDER_AMOUNT.MONTH"),
        });
      }

      //期間の初期値
      //システム月
      if (systemMonth <= 3) {
        //開始年度
        this.period.startYear = systemYear - 1;
        //終了年度
        this.period.endYear = systemYear;
      } else {
        //開始年度
        this.period.startYear = systemYear;
        //終了年度
        this.period.endYear = systemYear + 1;
      }

      //開始月度
      this.period.startMonth = 4;
      //終了月度
      this.period.endMonth = 3;
      //検索
      this.searchClick();
    },

    // 検索
    searchClick() {
      //チェック
      //月度差
      this.monthsDiff =
        (this.period.endYear - this.period.startYear) * 12 -
        parseInt(this.period.startMonth) +
        parseInt(this.period.endMonth);

      // console.log("this.monthsDiff---" + this.monthsDiff);

      if (this.monthsDiff < 0) {
        this.showFlag = false;
        Message.showError(
          t("message.CUS_M_ORDER_AMOUNT.DATE_COMPARE_MSG"),
          null
        );
        return;
      }

      if (this.monthsDiff >= 12) {
        this.showFlag = false;
        Message.showError(
          t("message.CUS_M_ORDER_AMOUNT.MONTHS_DIFF_MSG"),
          null
        );
        return;
      }

      this.showFlag = true;

      SearchInternalFactureData({
        searchStartYearMonth:
          this.period.startYear + "/" + this.period.startMonth,
        searchEndYearMonth: this.period.endYear + "/" + this.period.endMonth,
      })
        .then((res) => {
          //期間月度
          this.periodMonthList.length = 0;
          //開始年月
          let year = this.period.startYear;
          let month = this.period.startMonth;
          //月度値
          let monthValue;
          //年月
          let yearMonth;
          for (let i = 0; i <= this.monthsDiff; i++) {
            if (parseInt(month) + i <= 12) {
              //月度値
              monthValue = parseInt(month) + i;
              //年月
              if (monthValue < 10) {
                yearMonth = year + "_0" + monthValue;
              } else {
                yearMonth = year + "_" + monthValue;
              }
            } else {
              //月度値
              monthValue = parseInt(month) + i - 12;
              //年月
              if (monthValue < 10) {
                yearMonth = year + 1 + "_0" + monthValue;
              } else {
                yearMonth = year + 1 + "_" + monthValue;
              }
            }

            this.periodMonthList.push({
              title: monthValue + t("resource.CUS_M_ORDER_AMOUNT.MONTH"),
              yearMonth: yearMonth,
            });
          }
          //社内製造データのクリア
          this.internalFactureList.length = 0;

          // console.log("社内製造データのクリア");

          //for (
          //  let rowNum = 0;
          //  rowNum < res.internalFactureList.length;
          //  rowNum++
          //) {
          //  this.internalFactureList.push(res.internalFactureList[rowNum]);
          //}

          this.internalFactureList = res.internalFactureList;
          this.dataProcess();
          this.updateTableData(this.internalFactureList);

          // console.log(
          //   "this.internalFactureList---" +
          //     JSON.stringify(this.internalFactureList)
          // );
        })
        .catch((err) => {
          Message.showError(t("message.COMMON_MESSAGE.SEARCH_FAILURE"), null);
        })
        .finally(() => {
          this.showFlag = false;
        });
    },

    // 編集
    confirm() {
      // ADD 2024/12/16 ZLL 課題(#32906)_個人受注実績の見積件数が入力可能に変更 start↓
      // フォーカス削除
      this.$refs.confirmBtn.$el.blur();
      // ADD 2024/12/16 ZLL 課題(#32906)_個人受注実績の見積件数が入力可能に変更 end↑
      this.showFlag = true;
      //製品データのクリア
      this.internalFactureOutList.length = 0;

      for (let rowNum = 0; rowNum < this.internalFactureList.length; rowNum++) {
        //入力行目
        if (rowNum == 3 || rowNum == 4 || (rowNum >= 6 && rowNum <= 12)) {
          //区分
          let imKbn = this.internalFactureList[rowNum].imKbn;
          //月度列
          for (let colNum = 0; colNum < this.periodMonthList.length; colNum++) {
            //月度列
            let colName = "sum" + (colNum + 1);
            var numVal;
            if (
              imKbn === "3" ||
              imKbn === "5" ||
              imKbn === "5_1" ||
              imKbn === "9" ||
              imKbn === "10" ||
              imKbn === "11" ||
              imKbn === "12" ||
              imKbn === "12_1" ||
              imKbn === "12_2"
            ) {
              const moneyValue =
                this.internalFactureList[rowNum].dicNumValue[colName];
              numVal = formatCurrencyToNumber(moneyValue);
            } else {
              numVal = this.internalFactureList[rowNum].dicNumValue[colName];
            }

            //データの作成
            this.internalFactureOutList.push({
              imKbn: imKbn, //区分
              imYearMonth: this.periodMonthList[colNum].yearMonth, //年月
              imNumValue: numVal, //数量、金額値
              imUpdateUser: localStorage.getItem("userId"), //更新者
              // ucUpdateUser: localStorage.getItem("userId"), //更新者
            });
          }
        }
      }

      // console.log(
      //   "this.internalFactureOutList---" +
      //     JSON.stringify(this.internalFactureOutList)
      // );

      UpdateInternalManufactureData({
        internalFactureList: this.internalFactureOutList,
      })
        .then((res) => {
          // console.log("showSuccess");
          Message.showSuccess(t("message.COMMON.UPDATE_SUCCESS"));
        })
        .catch((err) => {
          // console.log("showError");
          Message.showError(t("message.COMMON.UPDATE_FAILURE"), null);
        })
        .finally(() => {
          this.showFlag = false;
        });
    },

    // 一覧表行目結合
    handleSpanMethod({ row, column, rowIndex, columnIndex }) {
      //生産報告(行:1～2、列：1～2)
      if (columnIndex === 0 && rowIndex === 0) {
        return {
          rowspan: 2,
          colspan: 2,
        };
      }

      if (
        (columnIndex === 0 && rowIndex === 1) ||
        (columnIndex === 1 && (rowIndex === 0 || rowIndex === 1))
      ) {
        return {
          rowspan: 0,
          colspan: 0,
        };
      }

      //②社内不良発生
      if (columnIndex === 0 || columnIndex === 1) {
        if (rowIndex === 3) {
          return {
            rowspan: 2,
            colspan: 1,
          };
        } else if (rowIndex === 4) {
          return {
            rowspan: 0,
            colspan: 1,
          };
        }
      }

      //不良修正
      if (columnIndex === 0 && rowIndex === 6) {
        return {
          rowspan: 3,
          colspan: 2,
        };
      }

      if (
        (columnIndex === 0 && (rowIndex === 7 || rowIndex === 8)) ||
        (columnIndex === 1 &&
          (rowIndex === 6 || rowIndex === 7 || rowIndex === 8))
      ) {
        return {
          rowspan: 0,
          colspan: 0,
        };
      }
    },

    updateTableData(dtTable) {
      if (dtTable.length < 15) {
        return;
      }

      // console.log("dtTable.length:" + dtTable.length);

      //1列目の表示
      dtTable[0].col1 = t("resource.INTERNAL_FACTURE.TABLE_CEL1_1");
      dtTable[2].col1 = t("resource.INTERNAL_FACTURE.TABLE_CEL3_1");
      dtTable[3].col1 = t("resource.INTERNAL_FACTURE.TABLE_CEL4_1");
      dtTable[5].col1 = t("resource.INTERNAL_FACTURE.TABLE_CEL6_1");
      dtTable[6].col1 = t("resource.INTERNAL_FACTURE.TABLE_CEL7_1");
      dtTable[9].col1 = t("resource.INTERNAL_FACTURE.TABLE_CEL10_1");
      dtTable[10].col1 = t("resource.INTERNAL_FACTURE.TABLE_CEL11_1");
      dtTable[11].col1 = t("resource.INTERNAL_FACTURE.TABLE_CEL12_1");
      dtTable[12].col1 = t("resource.INTERNAL_FACTURE.TABLE_CEL13_1");
      dtTable[13].col1 = t("resource.INTERNAL_FACTURE.TABLE_CEL14_1");
      dtTable[14].col1 = t("resource.INTERNAL_FACTURE.TABLE_CEL15_1");

      //2列目の表示
      dtTable[2].col2 = t("resource.INTERNAL_FACTURE.TABLE_CEL3_2");
      dtTable[3].col2 = t("resource.INTERNAL_FACTURE.TABLE_CEL4_2");
      dtTable[5].col2 = t("resource.INTERNAL_FACTURE.TABLE_CEL6_2");
      dtTable[9].col2 = t("resource.INTERNAL_FACTURE.TABLE_CEL10_2");
      dtTable[10].col2 = t("resource.INTERNAL_FACTURE.TABLE_CEL11_2");
      dtTable[11].col2 = t("resource.INTERNAL_FACTURE.TABLE_CEL12_2");
      dtTable[12].col2 = t("resource.INTERNAL_FACTURE.TABLE_CEL13_2");
      dtTable[13].col2 = t("resource.INTERNAL_FACTURE.TABLE_CEL14_2");
      dtTable[14].col2 = t("resource.INTERNAL_FACTURE.TABLE_CEL15_2");

      //3列目の表示
      for (let i = 0; i <= 14; i++) {
        dtTable[i].col3 = t(
          "resource.INTERNAL_FACTURE.TABLE_CEL" + (i + 1) + "_3"
        );
      }

      this.internalFactureList = dtTable;
      //小計の計算
      //月度リスト
      for (let colNum = 0; colNum <= this.monthsDiff; colNum++) {
        this.ubtotalCalculation(colNum + 1);
      }
      //this.internalFactureList.length = 0;

      /*
      console.log("dtTable.length:" + dtTable.length);

      for (let rowNum = 0; rowNum < dtTable.length; rowNum++) {
        for (let colNum = 0; colNum <= this.monthsDiff; colNum++) {
          //月度列
          let colName = "sum" + (colNum + 1);
          this.internalFactureList[rowNum].dicNumValue[colName] = parseInt(
            dtTable[rowNum].dicNumValue[colName]
          );
        }
        this.internalFactureList.push(dtTable[rowNum]);
      }*/

      //this.internalFactureList.push(dtTable);
      //  for (let rowNum = 0;)
      //  this.internalFactureList = dtTable;
    },

    //データの処理
    dataProcess() {
      this.internalFactureList.map((item) => {
        if (
          item.imKbn === "3" ||
          item.imKbn === "5" ||
          item.imKbn === "9" ||
          item.imKbn === "10" ||
          item.imKbn === "11" ||
          item.imKbn === "12"
        ) {
          for (let colNum = 0; colNum <= this.monthsDiff; colNum++) {
            //月度列
            let colName = "sum" + (colNum + 1);
            item.dicNumValue[colName] = formatStringToCurrency(
              item.dicNumValue[colName]
            );
          }
        }
      });
    },

    //データの変更
    changeCellData(rowNum, colNum) {
      // console.log("rowNum:" + rowNum + " colNum:" + colNum);

      this.$nextTick(() => {
        let colName = "sum" + (colNum + 1);
        if (
          rowNum === 2 ||
          rowNum === 4 ||
          rowNum === 9 ||
          rowNum === 10 ||
          rowNum === 11 ||
          rowNum === 12
        ) {
          //月度列
          this.internalFactureList[rowNum].dicNumValue[colName] =
            formatStringToCurrency(
              formatCurrencyToNumber(
                this.internalFactureList[rowNum].dicNumValue[colName]
              )
            );
        } else {
          this.internalFactureList[rowNum].dicNumValue[colName] = parseInt(
            this.$refs["inputRef" + rowNum + "_" + colNum][0].currentValue
          );
        }

        this.ubtotalCalculation(colNum + 1);

        /*
        //小計-1:受注金額-不良金額
        this.internalFactureList[5].dicNumValue[colName] =
          parseInt(this.$refs["inputRef2_" + colNum][0].currentValue) -
          parseInt(this.$refs["inputRef4_" + colNum][0].currentValue);

        //小計-2:受注金額-不良金額
        this.internalFactureList[13].dicNumValue[colName] =
          parseInt(this.$refs["inputRef9_" + colNum][0].currentValue) +
          parseInt(this.$refs["inputRef10_" + colNum][0].currentValue) +
          parseInt(this.$refs["inputRef11_" + colNum][0].currentValue) +
          parseInt(this.$refs["inputRef12_" + colNum][0].currentValue);

        //小計-3:材料費+刃具費+付帯費用+設備償却費
        this.internalFactureList[14].dicNumValue[colName] =
          parseInt(this.$refs["inputRef5_" + colNum][0].currentValue) -
          parseInt(this.$refs["inputRef9_" + colNum][0].currentValue) -
          parseInt(this.$refs["inputRef10_" + colNum][0].currentValue) -
          parseInt(this.$refs["inputRef11_" + colNum][0].currentValue) -
          parseInt(this.$refs["inputRef12_" + colNum][0].currentValue);
          */
      });
    },

    //セルの編集
    editCellData(row) {
      if (
        row.imKbn === "3" ||
        row.imKbn === "5" ||
        row.imKbn === "5_1" ||
        row.imKbn === "9" ||
        row.imKbn === "10" ||
        row.imKbn === "11" ||
        row.imKbn === "12" ||
        row.imKbn === "12_1" ||
        row.imKbn === "12_2"
      ) {
        return "input";
      } else {
        return "inputNumber";
      }
    },

    //Enter処理
    focusNextInput(rowIndex, index, columnProp, imKbn) {
      let columnIndex = this.periodMonthList.indexOf(columnProp);

      if (columnIndex == -1) {
        columnIndex = 0;
      }

      if (imKbn == "5") {
        rowIndex = rowIndex + 2;
      } else if (imKbn == "12") {
        rowIndex = 3;
      } else {
        rowIndex = rowIndex + 1;
      }

      if (rowIndex > this.internalFactureList.length - 1) {
        this.$refs["inputRef" + "3" + "_" + index][columnIndex].focus();
      } else {
        this.$refs["inputRef" + rowIndex + "_" + index][columnIndex].focus();
      }
    },

    changeCellDataToNumber(curRow, columnName) {
      curRow.dicNumValue[columnName] = formatCurrencyToNumber(
        curRow.dicNumValue[columnName]
      );
    },

    outPutClick() {
      this.$refs.outPut.$el.blur();

      this.monthsDiff =
        (this.period.endYear - this.period.startYear) * 12 -
        parseInt(this.period.startMonth) +
        parseInt(this.period.endMonth);

      if (this.monthsDiff < 0) {
        this.showFlag = false;
        Message.showError(
          t("message.CUS_M_ORDER_AMOUNT.DATE_COMPARE_MSG"),
          null
        );
        return;
      }

      if (this.monthsDiff >= 12) {
        this.showFlag = false;
        Message.showError(
          t("message.CUS_M_ORDER_AMOUNT.MONTHS_DIFF_MSG"),
          null
        );
        return;
      }

      this.showFlag = true;

      //期間月度
      let monthList = [];
      //開始年月
      let year = this.period.startYear;
      let month = this.period.startMonth;
      //月度値
      let monthValue;
      //年月
      let yearMonth;
      for (let i = 0; i <= this.monthsDiff; i++) {
        if (parseInt(month) + i <= 12) {
          //月度値
          monthValue = parseInt(month) + i;
          //年月
          if (monthValue < 10) {
            yearMonth = year + "_0" + monthValue;
          } else {
            yearMonth = year + "_" + monthValue;
          }
        } else {
          //月度値
          monthValue = parseInt(month) + i - 12;
          //年月
          if (monthValue < 10) {
            yearMonth = year + 1 + "_0" + monthValue;
          } else {
            yearMonth = year + 1 + "_" + monthValue;
          }
        }

        monthList.push(monthValue + t("resource.CUS_M_ORDER_AMOUNT.MONTH"));
      }

      outputExcelToZip(httpApi.OutInternalManufactureDataByExcel, {
        searchStartYearMonth:
          this.period.startYear + "/" + this.period.startMonth,
        searchEndYearMonth: this.period.endYear + "/" + this.period.endMonth,
        periodMonthList: monthList,
      })
        .then((res) => {
          //検索
          this.searchClick();
        })
        .finally(() => {
          this.showFlag = false;
        });
    },

    //小計の計算
    ubtotalCalculation(colNum) {
      //一覧データ
      let dtTable = this.internalFactureList;
      //月度列
      let colName = "sum" + colNum;

      //小計-1:受注金額-不良金額
      // dtTable[5].dicNumValue[colName] =
      //   parseInt(dtTable[2].dicNumValue[colName]) -
      //   parseInt(dtTable[4].dicNumValue[colName]);
      dtTable[5].dicNumValue[colName] = formatStringToCurrency(
        formatCurrencyToNumber(dtTable[2].dicNumValue[colName]) -
          formatCurrencyToNumber(dtTable[4].dicNumValue[colName])
      );

      //小計-2:受注金額-不良金額
      // dtTable[13].dicNumValue[colName] =
      //   parseInt(dtTable[9].dicNumValue[colName]) +
      //   parseInt(dtTable[10].dicNumValue[colName]) +
      //   parseInt(dtTable[11].dicNumValue[colName]) +
      //   parseInt(dtTable[12].dicNumValue[colName]);
      dtTable[13].dicNumValue[colName] = formatStringToCurrency(
        formatCurrencyToNumber(dtTable[9].dicNumValue[colName]) +
          formatCurrencyToNumber(dtTable[10].dicNumValue[colName]) +
          formatCurrencyToNumber(dtTable[11].dicNumValue[colName]) +
          formatCurrencyToNumber(dtTable[12].dicNumValue[colName])
      );

      //小計-3:材料費+刃具費+付帯費用+設備償却費
      // dtTable[14].dicNumValue[colName] =
      //   parseInt(dtTable[5].dicNumValue[colName]) -
      //   parseInt(dtTable[13].dicNumValue[colName]);
      dtTable[14].dicNumValue[colName] = formatStringToCurrency(
        formatCurrencyToNumber(dtTable[5].dicNumValue[colName]) -
          formatCurrencyToNumber(dtTable[13].dicNumValue[colName])
      );
      // this.$set(this.internalFactureList, 14, dtTable[14]);
    },
  },
};
</script>
